import React, { Component } from 'react';
import MarkerIcon from '../assets/marker.svg'

export class MapBoxMap extends Component {


    constructor(props) {
        super(props);

        this.state = {
            accessToken: null,
        };
    }

    componentDidMount() {           // initially fetch data
        // TO MAKE THE MAP APPEAR YOU MUST
        // ADD YOUR ACCESS TOKEN FROM
        // https://account.mapbox.com
        mapboxgl.accessToken = this.props.accessToken;
        const map = new mapboxgl.Map({
            container: 'map', // container ID
            center: [5.9878, 51.193715],
            zoom: 17 // starting zoom
        });
        // create a HTML element for each feature
        const container = document.createElement('div');
        const img = document.createElement('img');
        // container.innerHTML = DOMPurify.sanitize(MarkerIcon);
        img.src = `${MarkerIcon}`;


        // const width = 20;
        // const height = 40;

        // const img = new Image(width, height);
        // map is your Mapbox GL map object
        // img.onload = () => map.addImage('marker', img);

        container.appendChild(img);
        container.className = 'marker';

        new mapboxgl.Marker(container).setLngLat([5.987865, 51.193690]).addTo(map);  // Replace this line with code from step 5-2
        // map.on('dragend', () => {
        //     window.setTimeout(() => {
        //       refreshSearchResultOnMapAct(map)
        //     }, 0);
        //   });
        window.setTimeout(() => {
            map.resize();
        }, 10);
        window.setTimeout(() => {
            map.resize();
        }, 500);
        window.setTimeout(() => {
            map.resize();
        }, 1000);
        window.setTimeout(() => {
            map.resize();
        }, 1500);
          window.setTimeout(() => {
            map.resize();
        }, 2000);

    }
    render() {

        // const image = this.props.image;

        return (
            <div id="map"></div>
        )
    }

}